var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMagnifyingGlass = function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#266FF2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.875 18.75a7.875 7.875 0 1 0 0-15.75 7.875 7.875 0 0 0 0 15.75ZM16.443 16.444 21 21"
  }))));
};
export { SvgMagnifyingGlass as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ik1hZ25pZnlpbmdHbGFzcyI+CjxwYXRoIGlkPSJWZWN0b3IiIGQ9Ik0xMC44NzUgMTguNzVDMTUuMjI0MiAxOC43NSAxOC43NSAxNS4yMjQyIDE4Ljc1IDEwLjg3NUMxOC43NSA2LjUyNTc2IDE1LjIyNDIgMyAxMC44NzUgM0M2LjUyNTc2IDMgMyA2LjUyNTc2IDMgMTAuODc1QzMgMTUuMjI0MiA2LjUyNTc2IDE4Ljc1IDEwLjg3NSAxOC43NVoiIHN0cm9rZT0iIzI2NkZGMiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggaWQ9IlZlY3Rvcl8yIiBkPSJNMTYuNDQzNCAxNi40NDM4TDIwLjk5OTcgMjEuMDAwMiIgc3Ryb2tlPSIjMjY2RkYyIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+Cjwvc3ZnPgo=";